/* ET - Social Media Slider — mobile Swiper carousel + fullscreen media lightbox

   Swiper ships with the theme as et-swiper.min.js, loaded just before this file, so both are deferred and
   execute in document order. Everything is scoped to a section root, which lets several Social Media
   Slider sections live on one page and each drive its own carousel and lightbox.

   Above 989px Swiper is switched off through `breakpoints: { 990: { enabled: false } }` and the row is a
   plain centred flex row; the same media query drives the `et-sms--static` class that neutralises the
   inline transform and slide margins Swiper leaves behind. */

(function () {
  'use strict';

  if (window.__etSocialMediaSliderInit) return;
  window.__etSocialMediaSliderInit = true;

  var ROOT_SELECTOR = '.et-sms';
  var SWIPER_SELECTOR = '[data-et-sms-swiper]';
  var LIGHTBOX_SELECTOR = '[data-et-sms-lightbox]';
  var SLIDE_SELECTOR = '[data-et-sms-lb-slide]';
  var STATIC_CLASS = 'et-sms--static';
  var FOCUSABLE = 'button:not([disabled]), [href], video[controls], [tabindex]:not([tabindex="-1"])';

  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --------------------------------------------------------------------------------------------------
     Swiper bootstrapping
     -------------------------------------------------------------------------------------------------- */

  /* In the theme editor a section can be injected after the deferred bundle has already run, and on a cold
     first paint the bundle may not have executed yet — cover both without assuming an order. */
  function whenSwiperReady(cb) {
    if (window.Swiper) {
      cb();
      return;
    }

    var vendor = document.querySelector('script[src*="et-swiper.min.js"]');
    if (vendor) {
      vendor.addEventListener('load', cb, { once: true });
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function buildOptions(root, el) {
    /* Auto-advance is a merchant setting and is dropped entirely for visitors who asked for reduced
       motion. It only moves the carousel — the videos themselves never autoplay in the grid. */
    var wantsAutoplay = el.dataset.etSmsAutoplay === 'true' && !reducedMotionQuery.matches;

    return {
      /* Slide widths live in CSS per breakpoint so the card keeps its fixed 256px width and the peek of
         the previous and next card on each side, exactly as drawn. */
      slidesPerView: 'auto',
      spaceBetween: 8,
      centeredSlides: true,
      /* The mobile frame (1898:17667) draws a card peeking on BOTH sides of the centred one - the
         previous card's last 43px sit at the container's left edge while the scrollbar thumb is still
         at the start, i.e. on the very first card. Centring alone cannot draw that: with nothing
         before slide 1 the left half is simply empty, which is what the section shipped as. Looping
         puts the last card in that space.

         Safe with this section's wiring: the lightbox opens on `data-et-sms-open`, a 1-based index
         baked into the markup rather than read from DOM position, so Swiper's clones open the right
         media; clicks are delegated on the section root, so clones need no rebinding; and grid videos
         never autoplay (see openSlide/closeSlide), so a cloned <video> cannot start a second stream. */
      loop: true,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      threshold: 4,
      observer: true,
      observeParents: true,
      a11y: Object.assign({ enabled: true }, window.etSwiperA11y),
      autoplay: wantsAutoplay
        ? { delay: 4000, disableOnInteraction: true, pauseOnMouseEnter: true }
        : false,
      /* Progress bar rather than dots: a 4px thumb inside a 111px track, sized from the visible ratio. */
      scrollbar: {
        el: root.querySelector('[data-et-sms-scrollbar]'),
        draggable: true,
        dragSize: 'auto',
        hide: false
      },
      /* Off at desktop — the row becomes the static centred grid. spaceBetween/centeredSlides are reset
         too so `updateSlides` clears the inline margins it applied for the carousel. */
      breakpoints: {
        /* Swiper MERGES a breakpoint's params over the params already in effect, so any key a range
           omits keeps the other range's value. The `0` entry therefore has to restate every key the
           `990` entry changes — otherwise resizing down from desktop (or rotating an iPad, or the
           theme editor's device toggle) leaves the carousel with centeredSlides:false and
           spaceBetween:0, i.e. no centring, no peek and no gap. */
        0: { enabled: true, grabCursor: true, centeredSlides: true, spaceBetween: 8, loop: true },
        990: { enabled: false, grabCursor: false, centeredSlides: false, spaceBetween: 0, loop: false }
      }
    };
  }

  /* --------------------------------------------------------------------------------------------------
     Body scroll lock — reference counted so two sections can never fight over the restore value
     -------------------------------------------------------------------------------------------------- */

  var lockCount = 0;
  var savedOverflow = '';
  var savedPaddingRight = '';

  function lockScroll() {
    lockCount += 1;
    if (lockCount > 1) return;

    var doc = document.documentElement;
    var scrollbarWidth = window.innerWidth - doc.clientWidth;

    savedOverflow = doc.style.overflow;
    savedPaddingRight = doc.style.paddingRight;
    doc.style.overflow = 'hidden';
    if (scrollbarWidth > 0) doc.style.paddingRight = scrollbarWidth + 'px';
  }

  function unlockScroll() {
    if (lockCount === 0) return;
    lockCount -= 1;
    if (lockCount > 0) return;

    var doc = document.documentElement;
    doc.style.overflow = savedOverflow;
    doc.style.paddingRight = savedPaddingRight;
  }

  /* --------------------------------------------------------------------------------------------------
     Lightbox
     -------------------------------------------------------------------------------------------------- */

  function lightboxSlides(root) {
    var box = root.querySelector(LIGHTBOX_SELECTOR);
    if (!box) return [];
    return Array.prototype.slice.call(box.querySelectorAll(SLIDE_SELECTOR));
  }

  function stopSlide(slide) {
    if (!slide) return;
    var video = slide.querySelector('video');
    if (!video) return;

    video.removeAttribute('autoplay');
    video.pause();
    try {
      video.currentTime = 0;
    } catch (error) {
      /* Some browsers throw while metadata is still loading — nothing to reset in that case. */
    }
  }

  /* preload="none" keeps every lightbox video off the wire until it is actually opened, so playback is
     started here rather than through a markup autoplay attribute that would defeat that. */
  function startSlide(slide) {
    if (!slide) return;
    var video = slide.querySelector('video');
    if (!video) return;

    video.setAttribute('autoplay', '');
    var played = video.play();
    if (played && typeof played.catch === 'function') {
      played.catch(function () {
        /* Blocked by the browser's autoplay policy — the controls are visible, so the visitor can start it. */
      });
    }
  }

  function show(root, index) {
    var state = root.etSms;
    var slides = state.slides;
    if (!slides.length) return;

    var next = ((index % slides.length) + slides.length) % slides.length;

    slides.forEach(function (slide, i) {
      if (i === next) return;
      slide.hidden = true;
      stopSlide(slide);
    });

    slides[next].hidden = false;
    state.index = next;
    startSlide(slides[next]);
  }

  /* The focus trap only covers Tab. Without this a screen-reader user can still walk the page behind
     the dialog with the virtual cursor, so every sibling of the lightbox is made inert while it is open. */
  function hideBackground(root, hidden) {
    var state = root.etSms;
    if (!state || !state.lightbox) return;

    var parent = state.lightbox.parentNode;
    if (!parent) return;

    Array.prototype.forEach.call(parent.children, function (node) {
      if (node === state.lightbox) return;
      if (hidden) {
        node.setAttribute('inert', '');
        node.setAttribute('aria-hidden', 'true');
      } else {
        node.removeAttribute('inert');
        node.removeAttribute('aria-hidden');
      }
    });
  }

  function open(root, index, opener) {
    var state = root.etSms;
    if (!state || !state.lightbox || state.isOpen) return;

    state.opener = opener || null;
    state.isOpen = true;
    state.lightbox.hidden = false;
    lockScroll();
    hideBackground(root, true);
    show(root, index);

    /* The backdrop also carries data-et-sms-close, so the button is asked for explicitly. */
    var focusTarget = state.lightbox.querySelector('button[data-et-sms-close]');
    if (focusTarget) focusTarget.focus();
  }

  function close(root) {
    var state = root.etSms;
    if (!state || !state.lightbox || !state.isOpen) return;

    state.slides.forEach(function (slide) {
      slide.hidden = true;
      stopSlide(slide);
    });

    state.lightbox.hidden = true;
    state.isOpen = false;
    unlockScroll();
    hideBackground(root, false);

    if (state.opener && document.contains(state.opener)) state.opener.focus();
    state.opener = null;
  }

  function trapFocus(root, event) {
    var state = root.etSms;
    var nodes = Array.prototype.slice
      .call(state.lightbox.querySelectorAll(FOCUSABLE))
      .filter(function (node) {
        return node.getClientRects().length > 0 || node === document.activeElement;
      });

    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* --------------------------------------------------------------------------------------------------
     Wiring
     -------------------------------------------------------------------------------------------------- */

  function bindEvents(root) {
    /* Delegated: one listener per section covers every card and every lightbox control, and keeps
       working when the theme editor swaps the markup underneath. */
    root.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-et-sms-open]');
      if (opener && root.contains(opener)) {
        event.preventDefault();
        open(root, parseInt(opener.dataset.etSmsOpen, 10) - 1, opener);
        return;
      }

      if (!root.etSms || !root.etSms.isOpen) return;

      var state = root.etSms;

      if (event.target.closest('[data-et-sms-close]')) {
        close(root);
        return;
      }

      if (event.target.closest('[data-et-sms-prev]')) {
        show(root, state.index - 1);
        return;
      }

      if (event.target.closest('[data-et-sms-next]')) {
        show(root, state.index + 1);
        return;
      }

      /* Click-outside. The dialog covers the backdrop edge to edge and the visible slide is
         100% x 100% of the stage, so the empty area around the media always hit-tests to the slide —
         never to the backdrop, so the backdrop's own close hook can never fire. The three controls
         are consumed above, so anything left inside the lightbox that is not the media closes it. */
      if (
        state.lightbox &&
        state.lightbox.contains(event.target) &&
        !event.target.closest('.et-sms__lightbox-media')
      ) {
        close(root);
      }
    });

    root.etSmsKeydown = function (event) {
      var state = root.etSms;
      if (!state || !state.isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close(root);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(root, state.index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(root, state.index + 1);
      } else if (event.key === 'Tab') {
        trapFocus(root, event);
      }
    };

    document.addEventListener('keydown', root.etSmsKeydown);
  }

  function syncStatic(root) {
    root.classList.toggle(STATIC_CLASS, desktopQuery.matches);

    var swiper = root.etSwiper;
    if (!swiper || !swiper.autoplay) return;

    /* The carousel is disabled above 989px, so the autoplay timer is stopped rather than left ticking. */
    if (desktopQuery.matches) {
      swiper.autoplay.stop();
    } else if (swiper.params.autoplay && swiper.params.autoplay.enabled !== false && !swiper.autoplay.running) {
      swiper.autoplay.start();
    }
  }

  function init(root) {
    if (root.dataset.etSmsInit === 'true') return;
    root.dataset.etSmsInit = 'true';

    root.etSms = {
      lightbox: root.querySelector(LIGHTBOX_SELECTOR),
      slides: lightboxSlides(root),
      index: 0,
      isOpen: false,
      opener: null
    };

    bindEvents(root);
    syncStatic(root);

    var el = root.querySelector(SWIPER_SELECTOR);
    if (!el) return;

    whenSwiperReady(function () {
      root.etSwiper = new Swiper(el, buildOptions(root, el));
      syncStatic(root);
    });
  }

  function destroy(root) {
    close(root);

    if (root.etSmsKeydown) {
      document.removeEventListener('keydown', root.etSmsKeydown);
      root.etSmsKeydown = null;
    }

    if (root.etSwiper) {
      root.etSwiper.destroy(true, true);
      root.etSwiper = null;
    }

    root.etSms = null;
    delete root.dataset.etSmsInit;
  }

  /* The section wrapper itself carries .et-sms (schema `class`), and shopify:section:load hands us that
     very element — querySelectorAll only walks descendants, so the scope must be tested too or the
     slider never initialises after a theme-editor edit. */
  function each(scope, fn) {
    var node = scope || document;
    if (node.matches && node.matches(ROOT_SELECTOR)) fn(node);
    node.querySelectorAll(ROOT_SELECTOR).forEach(fn);
  }

  function boot(scope) {
    each(scope, init);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  }

  var onDesktopChange = function () {
    each(document, syncStatic);
  };

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', onDesktopChange);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(onDesktopChange);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    each(event.target, destroy);
  });

  /* Selecting a slide block in the theme editor scrolls the carousel to it. */
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (!root || !root.etSwiper || !root.etSwiper.enabled) return;

    var slide = event.target.closest('.et-sms__slide');
    if (!slide) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.et-sms__slide'));
    var index = slides.indexOf(slide);
    if (index > -1) root.etSwiper.slideTo(index);
  });
})();
